import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import enviro from 'enviro';

var BaseReporter = /*#__PURE__*/function () {
  function BaseReporter() {
    _classCallCheck(this, BaseReporter);

    this.debug = enviro.debug('react-rhumb') === 'true';
    this.libName = "react-rhumb";
  }

  _createClass(BaseReporter, [{
    key: "performanceMark",
    value: function performanceMark(name) {
      if (typeof performance.mark === 'function') {
        performance.mark(name);
      }
    }
  }, {
    key: "performanceEntries",
    value: function performanceEntries() {
      if (typeof performance.getEntries === 'function') {
        return performance.getEntries() || [];
      }

      return [];
    }
  }, {
    key: "toDuration",
    value: function toDuration(checks, timestamp, markers) {
      var longest = Math.max.apply(Math, _toConsumableArray(markers.filter(function (marker) {
        return Object.prototype.hasOwnProperty.call(checks, marker);
      }).map(function (marker) {
        return checks[marker].timestamp;
      })));
      return Math.max(0, longest - timestamp);
    }
  }, {
    key: "setCustomAttribute",
    value: function setCustomAttribute(attributeName, attributeValue) {
      if (window.newrelic) {
        window.newrelic.setCustomAttribute(attributeName, attributeValue);
      }
    }
  }, {
    key: "addPageAction",
    value: function addPageAction(actionName, actionPayload) {
      if (window.newrelic) {
        window.newrelic.addPageAction(actionName, actionPayload);
      }
    }
  }, {
    key: "report",
    value: function report(__action) {
      throw new Error('Reporters must define a custom report() function');
    }
  }]);

  return BaseReporter;
}();

export { BaseReporter as default };